import { isValid } from "date-fns";
import type React from "react";

import { formatDate } from "@/components/FormattedDate/FormattedDate";
import { useTranslation } from "@/translations";

interface CreatedAtAndUpdatedAtLabelProps {
  createdAt?: string;
  updatedAt?: string;
}

export function CreatedAtAndUpdatedAtLabel({ createdAt, updatedAt }: CreatedAtAndUpdatedAtLabelProps): React.ReactNode {
  const { t, i18n } = useTranslation();

  const isCreatedAtValid = createdAt ? isValid(new Date(createdAt)) : false;
  const isUpdatedAtValid = updatedAt ? isValid(new Date(updatedAt)) : false;

  let content = "";
  if (createdAt && isCreatedAtValid) {
    content += t("common.label.created-at", { date: formatDate(i18n, "date", createdAt) });
  }

  if (content && isUpdatedAtValid) {
    content += `, ${t("common.label.updated-at", { date: formatDate(i18n, "date", updatedAt!) })}`;
  }

  if (!content && isUpdatedAtValid) {
    content += t("common.label.updated-at", { date: formatDate(i18n, "date", updatedAt!) });
  }

  return <span className="text-caption text-text-secondary">{content}</span>;
}
